export default function () {
	return {
		show_global_search: false,
		is_tag: false,
	}
}
